import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogEditPrestamo } from 'src/app/components/prestamos/prestamos-validar.component';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { DialogEditPrestamoEjecutivo } from 'src/app/components/prestamos/prestamos-confirmar.component';
import { ConsultaPagosPrestamosService } from 'src/app/services/consulta-pagos-prestamos/consulta-pagos-prestamos.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { DialogValidarPagoAfiliado } from '../afiliacion/afiliado-validar-pago.component';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-consulta-pagos-afiliado',
  templateUrl: '../../pages/afiliacion/consulta-pagos/consulta-pagos-afiliado.component.html',
  styleUrls: ['../../pages/afiliacion/consulta-pagos/consulta-pagos-afiliado.css']
})
export class ConsultaPagosAfiliadoComponent implements OnInit {
  pagosPrestamo: any
  email: any
  postulacionesFinales: any
  postulacionSeleccionada: any
  allComplete: boolean = false
  recarga: boolean = false
  rol: string = localStorage.getItem("rol")
  idUsuario: string = localStorage.getItem("idUsuario");
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 5,  paginasTotal: 5 }
  tipoPostulacion: string = "Disponibles"
  idEjecutivo = localStorage.getItem("idUsuario")
  solicitud: any
  data: any
  regiones: any
  estado: any
  buscador: any =
    {
      rut: '', region: '0', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idPlanPago: '',
      estado: ['INGRESADA', 'RECHAZADA', 'APROBADA', 'PENDIENTE'],
      paginasTotal: 5, estadoselect: ['INGRESADA']
    }
  tipos: any


  constructor(public router: Router,
    public consultaPagosPrestamosService: ConsultaPagosPrestamosService,
    private afiliacionService: AfiliacionService,
    private dialog: MatDialog, private tiposService: TiposService) { }

  ngOnInit(): void { this.loadData() }

  loadData() {
    let vm = this;


    this.consultaPagosPrestamosService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))

    this.afiliacionService.traeEstados().then(estado => this.estado = estado).catch(error => console.log(error))

    this.postulacionesDisponiblesBuscador(false);


  }

  postulacionesDisponiblesBuscador(recarga?: boolean) {

    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();

    vm.tipoPostulacion = "Disponibles"

    if (recarga) {
      vm.config.currentPage = 1, vm.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['INGRESADA'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.id = '';
      this.buscador.idPlanPago = '';
    }
   

    this.buscador.estado = this.buscador.estadoselect;
   
    vm.afiliacionService.pagosDisponiblesBuscador(this.idUsuario, this.rol, this.buscador, localStorage.getItem("username")).then(
      (planes: any) => {
        planes.resultado.forEach(plan => { planes.seleccionado = false })
        vm.pagosPrestamo = planes.resultado
        vm.buscador.paginasTotal = planes.resultado.length
        vm.config.totalItems = planes.resultado.length
        if (this.buscador.currentPage < planes.cantidadPaginas && this.buscador.currentPage == 1) {
          this.config.itemsPerPage = planes.resultado.length
        }

        Swal.close();
      }
    )
      .catch(error => {
        console.log(error);

        vm.config.currentPage = 1
        vm.pagosPrestamo = []
        vm.config.totalItems = 0

        Swal.close();
        this.openAlertDialog('No se pudo obtener los pagos disponibles.', 'btn-danger')
      })
  }

  cambiaCantidadRegistros()
  {   
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1 
  }

  

  postulacionesAsignadas(recargar?: boolean) {

    this.tipoPostulacion = "Asignadas"

    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    vm.tipoPostulacion = "Asignadas"

    if (recargar) {
      this.config.currentPage = 1, this.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['EN VALIDACION'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.idSolicitud = '';
    }
    this.buscador.estado = this.buscador.estadoselect;
  
    this.afiliacionService.traePostulacionesAsignadas(vm.idUsuario, this.buscador).then
      (
        (postulaciones: any) => {
          console.log(postulaciones)

          vm.pagosPrestamo = postulaciones.resultado

          vm.config.totalItems = postulaciones.cantidadRegistros
          Swal.close();
        }
      )
      .catch(error => {
        console.log(error)
        this.openAlertDialog('No se encontraron pagos asignados.', 'btn-danger');
        vm.pagosPrestamo = []

        vm.config.currentPage = 1

        vm.config.totalItems = 0

        Swal.close();
      })
  }
  postulacionesAsignadasFiltros(recargar?: boolean) {

    this.tipoPostulacion = "Asignadas"

    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();


    if (recargar) {
      this.config.currentPage = 1, this.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['EN VALIDACION'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.id = '';
      this.buscador.estado = this.buscador.estadoselect;
    }
    this.buscador.estado = this.buscador.estadoselect;
      vm.afiliacionService.traePostulacionesAsignadas(this.idUsuario, this.buscador).then
      (
        (postulaciones: any) => {
         
          vm.pagosPrestamo = postulaciones.resultado

          vm.config.totalItems = postulaciones.cantidadRegistros
          Swal.close();
        }
      )
      .catch(error => {
        console.log(error)
        this.openAlertDialog('No se encontraron pagos asignados.', 'btn-danger');
        vm.pagosPrestamo = []

        vm.config.currentPage = 1

        vm.config.totalItems = 0

        Swal.close();
      })
  }
  buscar() {

    this.buscador.currentPage = 1, this.config.itemsPerPage = 5
   
    if ((this.buscador.fechaInicio != '' && this.buscador.fechaFin == '')
      || (this.buscador.fechaInicio == '' && this.buscador.fechaFin != '')) {
      this.openAlertDialog('Favor seleccionar fecha de inicio y fecha fin.', 'btn-danger')
      return
    } else {
      let fechaInicial = this.buscador.fechaInicio.split('-')
      let fechaFinal = this.buscador.fechaFin.split('-')
      if (this.buscador.estadoselect.length == 0) {
        this.openAlertDialog('Favor seleccionar al menos un estado.', 'btn-danger')
        return
      }

      if (parseInt(fechaInicial[0] + '' + fechaInicial[1] + '' + fechaInicial[2]) > parseInt(fechaFinal[0] + '' + fechaFinal[1] + '' + fechaFinal[2])) {

        this.openAlertDialog('Favor la fecha de inicio es mayor a la final.', 'btn-danger');
        this.buscador.fechaFin = "";
        return
      }
    }
    if (this.tipoPostulacion == 'Disponibles')
      this.postulacionesDisponiblesBuscador(false)
    else 
      this.postulacionesAsignadasFiltros(false)
  }

  openEditDialog(idPlanPago: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any): void {
    this.openDialogValidarPago(idPlanPago, mostrarEditar, disponiblePago);

  }

  openDialogValidarPago(id: any, mostrarEditar?: any, disponiblePago?: any) {
    this.afiliacionService.buscarPago(id).then(
      (response: any) => {
        let fechaPagoString =""
      	let fechaCuotaRealString = response.fechaCuota.split('-')[2] + '-' + response.fechaCuota.split('-')[1] + '-' +
        response.fechaCuota.split('-')[0]    
       if(response.fechaPago){
          fechaPagoString = response.fechaPago.split('-')[2] + '-' + response.fechaPago.split('-')[1] + '-' +
          response.fechaPago.split('-')[0]
        } 
       
        let data: any =
        {
          id: response.id,
          rutUsuario: response.rut,
          nombreUsuario: response.nombreUsuario,
          idUsuario:response.usuarioId,
          monto: response.monto,
          fechaCuota: fechaCuotaRealString,
          fechaPago: fechaPagoString,
          fechaPagoIndicado: response.fechaCuota,
          mostrarEditar: mostrarEditar,
          mostrarBotones: false,
          disponiblePago: disponiblePago,
          nombreMotivoRechazo: response.nombreMotivoRechazo,
          motivoRechazo: response.motivoRechazo,
          motivoAnulacion: response.motivoAnulacion,
          estado: response.estado,
          tipoPostulacion:this.tipoPostulacion
        }
        let vm = this;

        const dialogRef = vm.dialog.open(DialogValidarPagoAfiliado,
          { width: '40%', data: data })
        Swal.close();

        dialogRef.afterClosed().subscribe(() => {
          if (vm.tipoPostulacion == 'Disponibles') {
            this.postulacionesDisponiblesBuscador(false)
        } else {
            this.postulacionesAsignadas(false)
        }

        })

      }
    ).catch(error => {
      console.log(error)
      Swal.close();
      this.openAlertDialog('Ha ocurrido un error para visualizar el pago.', 'btn-danger')
    })
  }

  verArchivo(postulacionId: any) {
    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    this.consultaPagosPrestamosService.traeArchivos(postulacionId).then
      (
        (archivos: any) => {
          archivos.forEach(archivo => {
            var fileURL = `${environment.urlBlob}/${archivo.url}`
            window.open(fileURL);
          })

        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
      })
  }
  asignaPostulacion(id: any) {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let postulacion = [{ id: id }]
    let vm = this

    this.afiliacionService.asignaPostulacion(id, this.idEjecutivo).then
      (
        () => {
          if (vm.buscador.paginasTotal == 1 && vm.buscador.currentPage > 1) {

            vm.buscador.currentPage = vm.buscador.currentPage - 1;
            vm.config.currentPage = this.buscador.currentPage
          }
          vm.openAlertDialog('La cuota de pago se ha asignado exitosamente.', 'btn-success')
          setTimeout(function () {
            vm.postulacionesDisponiblesBuscador(false)
          }, 500);
          Swal.close();
        }
      )
      .catch
      (
        error => {
          Swal.close();
          console.log(error)
          vm.openAlertDialog('La cuota de pago no se ha podido asignar.', 'btn-danger')
        }
      )
  }
  asignarSeleccionados() {
    let postulacionesSeleccionadas: any = []

    this.pagosPrestamo.filter(pos => pos.seleccionado).forEach(pos => {
      postulacionesSeleccionadas.push({ id: pos.id })
    })

    let vm = this
   
    if (postulacionesSeleccionadas.length == 0) {
      this.openAlertDialog("Debe seleccionar al menos un pago.", "btn-danger")
      return
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();

    this.afiliacionService.asignaPostulaciones(postulacionesSeleccionadas, this.idEjecutivo).then
      (
        () => {
          if (vm.buscador.paginasTotal == postulacionesSeleccionadas.length && vm.buscador.currentPage > 1) {

            vm.buscador.currentPage = vm.buscador.currentPage - 1;
            vm.config.currentPage = this.buscador.currentPage
          }

          vm.openAlertDialog('La solicitudes de pago se han asignado exitosamente.', 'btn-success')

          this.postulacionesDisponiblesBuscador(false);


          Swal.close();
        }
      )
      .catch(error => {
        Swal.close();
        console.log(error)
        vm.openAlertDialog('Las solicitudes de pago no se ha podido asignar.', 'btn-danger')
      })
  }


  someComplete(): boolean {
    if (isNullOrUndefined(this.pagosPrestamo?.seleccionado)) { return false }

    return this.pagosPrestamo.filter(p => p.seleccionado).length > 0 && !this.allComplete
  }
  setAll(seleccionado: boolean) {
    this.allComplete = seleccionado

    if (this.pagosPrestamo == null) { return }

    this.pagosPrestamo.forEach(pos => { pos.seleccionado = seleccionado })
  }
  updateAllComplete() {
    this.allComplete = this.pagosPrestamo != null && this.pagosPrestamo
      .slice(this.config.indexInicial, this.config.indexMaximo)
      .every(p => p.seleccionado)
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }
 

  pageChanged(event: any) {
    this.config.currentPage = event, this.buscador.currentPage = event    
    if (this.tipoPostulacion == 'Disponibles') {
      console.log("dispo");
      this.postulacionesDisponiblesBuscador(false)
    }

    if (this.tipoPostulacion == 'Asignadas') {
      console.log("asig");
      this.postulacionesAsignadas(false)
    }
    

    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)

    //this.updateAllComplete()
  }


  

  detalleBeneficiario(rutAfiliado: any) {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();

    let data: any = {}

    this.consultaPagosPrestamosService.traeUsuario(rutAfiliado.split('-')[0]).then
      (
        (usu: any) => {
          console.log(usu)

          data.nombre = usu.nombres + ' ' + usu.apellidoPaterno + ' ' + usu.apellidoMaterno
          data.telefono = usu.telefonoFijo
          data.celular = usu.telefonoMovil
          data.mail = usu.email
          data.prevision = usu.prevision
          data.beneficiarios = usu.carga
        }
      )
      .catch(error => console.log(error))
    Swal.close();
    const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

    dialogRef.afterClosed().subscribe(() => { })
  }

}